export default __webpack_public_path__ + "static/media/editIcon.9b527df0.svg";